module.exports = __webpack_public_path__ + "static/media/440551964_1238188300486710_8261742102983254570_n.26cf8c87.jpg";